export default {
  fire() {
    $('.add-children-item, .children-item').hide();

    $('select[name="personal[children]"]').change(function (){
      
      if($(this).val() == 1)
        $('.add-children-item, .children-item').show();
      else
        $('.add-children-item, .children-item').hide();
    });

    var example = $('.children-item').first();

    $('.add-children-item').on('click', function () {
      var last = $('.children-item').last();
      var language = example.clone();

      last.after(language);
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/components/work-children.js